import React from 'react';
import { useTransform } from 'framer-motion';
import Link from '~/components/Link';
import { Card, Content, Title } from './StickyCardsStackItem.styles';
import Image from '../Image';
import useDeviceDetection from '../../hooks/useDeviceDetection';

const StickyCardsStackItem = ({ item, index, distanceWhenSticky, elementScrollY }) => {
  const scale = useTransform(elementScrollY, [0, 3000], [1, 0.8]);
  const { isDesktop } = useDeviceDetection();
  const y = useTransform(elementScrollY, [0, 3000], [0, -175]);

  const { image, mainTitle, linkTitle, ctaUrl } = item;

  if (!item) {
    // ghost card to make sure the 'last' item is not scrolling beyond the other items
    return (
      <Card index={index} distanceWhenSticky={distanceWhenSticky} style={isDesktop && { scale }}>
        <Content />
      </Card>
    );
  }

  return (
    <Card index={index} distanceWhenSticky={distanceWhenSticky} style={isDesktop && { scale, y }}>
      {image?.[0] && <Image image={image[0]} lazyload={false} />}
      <Content>
        {mainTitle && <Title>{mainTitle}</Title>}
        {linkTitle && ctaUrl && (
          <>
            <Link href={ctaUrl.url} type={ctaUrl.type}>
              {linkTitle}
            </Link>
            <Link href={ctaUrl.url} type={ctaUrl.type} className="clickable-overlay" />
          </>
        )}
      </Content>
    </Card>
  );
};

export default StickyCardsStackItem;
